export { createManagedQueryLink } from './managedQueryLink';
